import type { IValueAndUnit } from "@/interfaces/IValueAndUnit"
import type { IEquipmentWheelsAndTiresSpecifications } from "@/interfaces/equipments/IEquipmentWheelsAndTiresSpecifications"
import Base from "@/models/Base"
import ValueAndUnit from "../ValueAndUnit"

class EquipmentWheelsAndTiresSpecifications extends Base implements IEquipmentWheelsAndTiresSpecifications {
  frontTrackWidth: IValueAndUnit<number>
  rearTrackWidth: IValueAndUnit<number>
  wheelbase: IValueAndUnit<number>
  frontWheelDiameter: IValueAndUnit<number>
  rearWheelDiameter: IValueAndUnit<number>
  rearAxle: IValueAndUnit<number>
  frontTyreType: string
  frontTyrePressure: IValueAndUnit<number>
  rearTyreType: string
  rearTyrePressure: IValueAndUnit<number>

  constructor(equipmentWheelsAndTiresSpecifications?: any) {
    super(equipmentWheelsAndTiresSpecifications)
    this.frontTrackWidth = new ValueAndUnit(equipmentWheelsAndTiresSpecifications?.frontTrackWidth)
    this.rearTrackWidth = new ValueAndUnit(equipmentWheelsAndTiresSpecifications?.rearTrackWidth)
    this.wheelbase = new ValueAndUnit(equipmentWheelsAndTiresSpecifications?.wheelbase)
    this.frontWheelDiameter = new ValueAndUnit(equipmentWheelsAndTiresSpecifications?.frontWheelDiameter)
    this.rearWheelDiameter = new ValueAndUnit(equipmentWheelsAndTiresSpecifications?.rearWheelDiameter)
    this.rearAxle = new ValueAndUnit(equipmentWheelsAndTiresSpecifications?.rearAxle)
    this.frontTyreType = equipmentWheelsAndTiresSpecifications?.frontTyreType
    this.frontTyrePressure = new ValueAndUnit(equipmentWheelsAndTiresSpecifications?.frontTyrePressure)
    this.rearTyreType = equipmentWheelsAndTiresSpecifications?.rearTyreType
    this.rearTyrePressure = new ValueAndUnit(equipmentWheelsAndTiresSpecifications?.rearTyrePressure)
  }
}

export default EquipmentWheelsAndTiresSpecifications
